import { Sparkle } from "lucide-react";

const ITEMS = [
  "Ask again.",
  "Listen longer.",
  "Love louder.",
  "You are not alone.",
  "Call or text 988 — free, 24/7",
  "Walking for Hope",
  "Your story is not over.",
];

const Row = ({ ariaHidden }) => (
  <div
    aria-hidden={ariaHidden || undefined}
    className="flex shrink-0 items-center gap-10 pr-10"
  >
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center gap-10 whitespace-nowrap">
        <span className="font-serif text-lg sm:text-xl italic text-cream/95">{item}</span>
        <Sparkle className="h-3.5 w-3.5 text-plum" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    className="overflow-hidden border-y border-gold/25 bg-sage py-4"
    data-testid="motto-marquee"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row ariaHidden />
    </div>
  </div>
);
